import React from 'react';

export default function IconTW() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#FF4B55"
                d="M31.448 21.483H.552A.552.552 0 0 1 0 20.93V1.069C0 .764.247.517.552.517h30.896c.305 0 .552.247.552.552v19.862a.552.552 0 0 1-.552.552Z"
            />
            <path
                fill="#41479B"
                d="M.552.517h14.896c.305 0 .552.247.552.552v9.38a.552.552 0 0 1-.552.551H.552A.552.552 0 0 1 0 10.448V1.07C0 .764.247.517.552.517Z"
            />
            <path
                fill="#F5F5F5"
                d="M6.025 5.759c0-.545.22-1.039.578-1.396L4.948 3.89c-.096-.028-.165.091-.093.16l1.238 1.198-1.67.418c-.097.024-.097.162 0 .186l1.67.418-1.238 1.197c-.072.07-.003.189.093.161l1.655-.473a1.969 1.969 0 0 1-.578-1.396ZM6.604 4.362c.357-.357.85-.578 1.396-.578.545 0 1.038.22 1.395.578l.474-1.655c.027-.096-.092-.165-.161-.093L8.51 3.852l-.417-1.67c-.025-.097-.162-.097-.187 0l-.417 1.67-1.197-1.238c-.07-.072-.19-.003-.162.093l.474 1.655ZM9.396 7.156c-.358.357-.851.578-1.396.578-.545 0-1.039-.221-1.396-.578L6.13 8.81c-.027.096.092.165.162.093l1.197-1.238.418 1.671c.024.097.162.097.186 0l.418-1.67 1.197 1.237c.07.072.188.003.161-.093l-.473-1.654ZM11.577 5.666l-1.67-.418 1.237-1.197c.072-.07.003-.189-.093-.162l-1.655.474c.358.357.578.85.578 1.396 0 .545-.22 1.038-.578 1.396l1.655.473c.096.027.165-.092.093-.161L9.906 6.269l1.671-.417c.097-.024.097-.162 0-.186Z"
            />
            <path
                fill="#F5F5F5"
                d="M8 7.331a1.572 1.572 0 1 0 0-3.145 1.572 1.572 0 0 0 0 3.145Z"
            />
        </svg>
    );
}
